import { defaultPieces } from 'react-chessboard';
import type { Color } from '../../shared/protocol.ts';
import { useT } from '../app/preferences.ts';
import { Segmented } from './Segmented.tsx';

type Choice = Color | 'random';

/** White / surprise / black, shown with a big king so it works before kids can read. */
export function ColorChoice({ name, value, onChange }: { name: string; value: Choice; onChange: (c: Choice) => void }) {
  const t = useT();
  const king = (c: Color) => (
    <span className="choice-piece" aria-hidden="true">
      {defaultPieces[`${c}K`]?.({ svgStyle: { width: '100%', height: '100%' } })}
    </span>
  );

  return (
    <div className="field">
      <span className="field-label">{t('color.label')}</span>
      <Segmented<Choice>
        name={name}
        label={t('color.label')}
        value={value}
        onChange={onChange}
        options={[
          { value: 'w', label: <>{king('w')}{t('color.w')}</> },
          {
            value: 'random',
            label: (
              <>
                <span className="choice-emoji emoji" aria-hidden="true">
                  🎲
                </span>
                {t('color.random')}
              </>
            ),
          },
          { value: 'b', label: <>{king('b')}{t('color.b')}</> },
        ]}
      />
    </div>
  );
}
